import React from 'react';
import { FaFilter } from 'react-icons/fa';

interface FloatingFilterButtonProps {
  onClick: () => void;
  show: boolean;
}

const FloatingFilterButton: React.FC<FloatingFilterButtonProps> = ({ onClick, show }) => {
  if (!show) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-colors z-40 flex items-center justify-center"
      aria-label="Open filters"
    >
      <FaFilter className="w-5 h-5" />
    </button>
  );
};

export default FloatingFilterButton;

